<div class="v2-button" [ngClass]="classes">
    <!-- Default -->
    <button mat-button *ngIf="variant === 'flat'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
    }" [disabled]="disabled || loading" type="button">
        <div class="button-content">
            <div *ngIf="text && !loading">{{text}}</div>
            <vui-progress-spinner
                *ngIf="loading"
                [mode]="'indeterminate'"
                [color]="color"
                class="button-spinner"
                [diameter]="20"
                [strokeWidth]="2"
            ></vui-progress-spinner>
            <mat-icon *ngIf="icon && !loading" [svgIcon]="icon"></mat-icon>
        </div>
    </button>

    <button mat-stroked-button *ngIf="variant === 'stroked'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
    }" [disabled]="disabled || loading" type="button">
        <div class="button-content">
            <div *ngIf="text && !loading">{{text}}</div>
            <vui-progress-spinner
                *ngIf="loading"
                [mode]="'indeterminate'"
                [color]="color"
                class="button-spinner"
                [diameter]="20"
                [strokeWidth]="2"
            ></vui-progress-spinner>
            <mat-icon *ngIf="icon && !loading" [svgIcon]="icon"></mat-icon>
        </div>
    </button>

    <button mat-raised-button *ngIf="variant === 'raised'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
    }" [disabled]="disabled || loading" type="button">
        <div class="button-content">
            <div *ngIf="text && !loading">{{text}}</div>
            <vui-progress-spinner
                *ngIf="loading"
                [mode]="'indeterminate'"
                [color]="color"
                class="button-spinner"
                [diameter]="20"
                [strokeWidth]="2"
            ></vui-progress-spinner>
            <mat-icon *ngIf="icon && !loading" [svgIcon]="icon"></mat-icon>
        </div>
    </button>
</div>